import { render } from "./IndexResponseBox.vue?vue&type=template&id=37c2b346&scoped=true"
import script from "./IndexResponseBox.vue?vue&type=script&lang=js"
export * from "./IndexResponseBox.vue?vue&type=script&lang=js"

import "./IndexResponseBox.vue?vue&type=style&index=0&id=37c2b346&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c2b346"]])

export default __exports__